module.exports = __webpack_public_path__ + "static/media/YakYik.1fbdf4e0.gif";